import React, { useCallback } from "react";

import { useForm } from "react-hook-form";

import useTranslations from "../../hooks/useTranslations";
import useUserUpdatePassword from "../../graphql/hooks/mutations/useUserUpdatePassword";

import {
  Modal,
  ModalBody,
  ModalHeader,
  ModalActions,
  Link,
} from "../wombat-ui";
import Button from "../wombat-ui/components/Button";

import { Input } from "../wombat-ui";
import useAddNotification from "../../hooks/useAddNotification";
import { useHistory } from "react-router";

type UpdatePasswordInput = {
  password?: string;
  passwordConfirmation?: string;
};

type UpdatePasswordModalFormProps = {};

const UpdatePasswordModalForm: React.FC<UpdatePasswordModalFormProps> = () => {
  const t = useTranslations();
  const history = useHistory();

  const [addNotification] = useAddNotification();

  const {
    register,
    handleSubmit,
    errors,
    watch,
    formState,
  } = useForm<UpdatePasswordInput>({ mode: "onChange" });

  const { password } = watch();

  const [userUpdatePassword] = useUserUpdatePassword();
  const onSubmit = useCallback(async ({ password, passwordConfirmation }) => {
    try {
      await userUpdatePassword({
        variables: {
          password,
          passwordConfirmation,
        },
      });
      addNotification({
        variables: {
          title: t(`userProfile.notification.success`) as string,
          body: t(`userProfile.notification.passwordUpdated`) as string,
          status: "success",
        },
      });
      history.push("/profile");
    } catch (error) {
      addNotification({
        variables: {
          title: t(`userProfile.notification.error`) as string,
          status: "error",
        },
      });
    }
  }, []);

  // TODO: there's probably a better way to do this
  if (errors?.passwordConfirmation?.type === "equalToPassword") {
    errors.passwordConfirmation.message = t("userProfile.error.password");
  }

  return (
    <Modal>
      <form
        className="relative block"
        id="updatePasswordForm"
        onSubmit={handleSubmit(onSubmit)}
      >
        <ModalHeader>{t("userProfile.updatePassword")}</ModalHeader>
        <ModalBody>
          <div className="grid grid-cols-1 col-span-4 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div className="sm:col-span-6">
              <Input
                label={t("userProfile.password") as string}
                error={errors?.password}
                type="password"
                autoComplete="new-password"
                name={`password`}
                ref={register({ minLength: 8, required: true })}
              />
            </div>
            <div className="sm:col-span-6">
              <Input
                label={t("userProfile.passwordConfirmation") as string}
                error={errors?.passwordConfirmation}
                type="password"
                autoComplete="new-password"
                name={`passwordConfirmation`}
                ref={register({
                  required: true,
                  validate: {
                    equalToPassword: (value) => value === password,
                  },
                })}
              />
            </div>
          </div>
        </ModalBody>
        <ModalActions>
          <Link type="button" variant="button-subtle" to="/profile">
            {t("userProfile.cancel")}
          </Link>
          <Button type="submit" disabled={!formState.isValid}>
            {t("userProfile.submit")}
          </Button>
        </ModalActions>
      </form>
    </Modal>
  );
};

export default React.memo(UpdatePasswordModalForm);
